import React from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default function rishiKeshPlant() {
  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content">
                        <h2>Rishikesh Plant</h2>

                        <div class="row">
                          <div class="col-sm-6">
                            <img
                              src="../images/RishikeshPlant.jpg"
                              class="img-responsive"
                            />
                          </div>
                          <div class="col-sm-6">
                            <div class="address">
                              <ul>
                                <li>
                                  <img src="../images/person.png" />{" "}
                                  <span>Contact Person Name : </span> Shri
                                  Sanjay Kumar
                                </li>
                                <li>
                                  <img src="../images/desi.png" />{" "}
                                  <span>Designation : </span> General Manager,
                                  Additional Charge
                                </li>
                                <li>
                                  <img src="../images/home-icon.png" />{" "}
                                  <span>Address : </span> Virbhadra,
                                  Rishikesh-249202 (Uttarakhand)
                                </li>
                                <li>
                                  <img src="../images/cell_icon.gif" />{" "}
                                  <span>Telephone : </span> 0135-2450175,
                                  9868327477
                                </li>

                                <li>
                                  <img src="../images/fax.png" />
                                  <span> Fax No. : </span> 0135-2450176
                                </li>
                                <li>
                                  <img src="../images/mouse_icon.gif" />{" "}
                                  <span>E-mail : </span> s.kumaridpl@gmail.comm
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <br />

                        <p>
                          Rishikesh plant is located on the Haridwar-Joshimath
                          highway on the periphery of Rishikesh Municipality in
                          Uttarakhand State in the serenity of Mountainous
                          landscape on the bank of holy river Ganges. Rishikesh
                          Township comprising Plant & Colony is spread over a
                          vast 834 acres of land (3.38 million sq. mts) and is
                          well connected with road, rail and air.
                        </p>
                        <p>
                          The scenario offers greenery, climes and non- polluted
                          air. The plant was commissioned in 1967 and had
                          largest antibiotics fermentation facility with 44 nos.
                          of Fermentors (50m3 capacity each) for penicillin-G,
                          Tetracycline, Oxytetracycline and Streptomycin etc.
                          and their purification facilities.
                        </p>

                        <p>
                          Presently only formulation manufacturing facilities
                          are in operation, and nearly 50 Formulations of wide
                          therapeutic range are being produced. The unit is
                          revised Sch. M compliant, 2 out of 4 sections viz.
                          General Tablets section and Non B lactum capsule
                          sections have been declared " WHO : GMP Compliant ".
                          COPPs have been obtained for 4 products and another 5
                          COPPs are under process.
                        </p>
                        <p>
                          It has large production capacity for manufacturing of
                          Formulations like tablets (765 million nos. / per
                          annum ) and capsules both Beta & Non Beta lectum (390
                          million nos. per annum)
                        </p>
                        <p>
                          It is endowed with the capacity to manufacture Oral
                          Contraceptive and Emergency Pills ( OCPs & ECPs ) and
                          is one of the five regular suppliers of these pills to
                          Ministry of Heath & Family Welfare, Government of
                          India.
                        </p>
                        <p>
                          The production facilities are fully supported by well
                          equipped Quality Control Department with Good
                          Laboratory Practices, apart from Formulation
                          Development Research Laboratory (FDRL).
                        </p>
                        <p>
                          The plant has a modern Biological Treatment Plant
                          (BTP) with 14000 cum / day treating capacity, which is
                          a significant and measurable contribution towards
                          development of clean technologies and innovative
                          solutions for the Environmental problems. Rishikesh
                          plant has received the National Award for prevention
                          of pollution -1992 from the President of India on 6
                          August, 1994.
                        </p>
                        <p>
                          IDPL Rishikesh is having a vast township with 2700
                          Quarters. Besides, there are good no. of shops /
                          shopping centres , one Intermediate college, one
                          kendriya Vidyalaya, one Post Office / Police station,
                          play grounds and a Community Centre.
                        </p>

                        <div class="clearfix"></div>

                        <div class="">
                          <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27620.419902930273!2d78.25807999451472!3d30.078359595120723!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39093e680c1bcc75%3A0xb53d18f2df061b76!2sIDPL+Factory%2C+Labor+Colony%2C+Rishikesh%2C+Uttarakhand+249203!5e0!3m2!1sen!2sin!4v1449134862248"
                            width="100%"
                            height="250"
                            frameborder="0"
                            style={{ border: "0;" }}
                            allowfullscreen
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
